import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Discussion from 'flarum/common/models/Discussion';
import extractText from 'flarum/common/utils/extractText';
import FieldList from '../fields/FieldList';
import DiscussionFormModal from '../modals/DiscussionFormModal';
import Form from '../models/Form';
import Submission from '../models/Submission';
import isHorizontalLayout from '../utils/isHorizontalLayout';

interface DiscussionSubmissionAttrs {
    form: Form
    discussion: Discussion
}

export default class DiscussionSubmission implements ClassComponent<DiscussionSubmissionAttrs> {
    view(vnode: Vnode<DiscussionSubmissionAttrs, this>) {
        const {form, discussion} = vnode.attrs;

        const submissions = discussion.formulaireSubmissions(); // Use the relationship, that way we are certain all submissions in there are already for the correct user
        const submission = submissions ? submissions.find(submission => {
            const thisForm = submission.form();
            return thisForm && thisForm.id() === form.id();
        }) : null;

        return m('.FormulaireDiscussionForms', {
            className: isHorizontalLayout('DiscussionView') ? 'Formulaire-horizontal-layout' : '',
        }, [
            m('h3', form.title()),
            form.attribute('canSubmit') ? Button.component({
                onclick: () => {
                    app.modal.show(DiscussionFormModal, {
                        form,
                        discussion,
                    });
                },
                className: 'Button Button--icon',
                icon: 'fas fa-pen',
                title: extractText(app.translator.trans('kilowhat-formulaire.forum.discussion-submission.edit')),
            }) : null,
            this.submissionView(form, submission),
        ]);
    }

    submissionView(form: Form, submission: Submission | null | undefined) {
        if (!submission) {
            return m('p', app.translator.trans('kilowhat-formulaire.forum.discussion-submission.empty'));
        }

        const list = new FieldList({
            configs: form.template()!,
            submission: submission.formData()!,
        });

        return list.listView(true);
    }
}
